module.exports = __webpack_public_path__ + "img/slide-placeholder_small.c4cf9c65.jpg";